import getFirebase from 'helper/getFirebase';
import { LiveClassEventType } from '../utils/consts';
import createLiveClassDoc from '../utils/createLiveClassDoc';

export default async function updateChat(classId, userId, companyId, message) {
  const { firebaseDB } = await getFirebase();
  const liveCLassCollection = firebaseDB.collection('live-class-events');
  return liveCLassCollection.add(
    createLiveClassDoc(LiveClassEventType.CHAT, { classId, userId, companyId, message })
  );
}
